<template>
    <div class="post-wrapper conversation card card-shadow" :class="{'compact': displayMode === 'small' && !isHelpdesk, 'unread' : topic.unread, 'single-topic': singleTopic}">

        <topic-scroll-to-newest :singleTopic="singleTopic" :itemHighlighted="itemHighlighted" :topic="topic" :viewType="viewType"></topic-scroll-to-newest>

        <topic-helpdesk-status-switch :topic="topic"></topic-helpdesk-status-switch>

        <moodview-topic-top :topic="topic" :viewType="viewType"></moodview-topic-top>

        <!-- post top -->
        <!--<div class="post-top" v-if="topic.status == 'invisible' && topic.user().id == user.id">-->
        <div class="post-top">
            <div v-if="isUsersInvisibleIntroductionTopic" class="user-visible">
                {{ translations['introduce.visible'] }}
            </div>

            <template v-if="topic.event.id && !eventRoute">
                <div class="event-top">
                    <a :href="'/events/' + topic.event.slug" class="event-link tw-rounded-t tw-w-full tw-relative tw-mb-1 tw-flex tw-items-center">
                        <div class="box-icon tw-h-full tw-relative">
                            <calendar-icon :tEvent="topic.event" size="xlarge" format="YYYY-MM-DD HH:mm" class="calendar-icon-position"></calendar-icon>
                        </div>
                        <div class="tw-w-full tw-flex tw-justify-between tw-py-3 tw-pr-4">
                            <div class="tw-flex tw-flex-col tw-flex-1">
                                <div class="group-title tw-text-lg tw-flex tw-items-center tw-mb-2">
                                    <h1 v-text="topic.event.title" class="event-title tw-font-semibold"></h1>
                                </div>
                                <p class="event-start-date tw-text-sm tw-text-gray-400" v-text="start_date"></p>
                            </div>
                            <div class="tw-flex tw-items-center">
                                <i class="far fa-chevron-right tw-text-base tw-text-gray-400"></i>
                            </div>
                        </div>
                    </a>
                </div>
            </template>
            
            <div class="card-inner flex">
                <div class="flex-1 flex-no-padding">
                    <topic-user-icon :topic="topic" :class="{'events-topic': topic.event.id}"></topic-user-icon>
                </div>
                <div class="flex-16 flex-no-padding">
                    <div class="post-top-content">
                        <topic-top-meta :topic="topic" :viewType="viewType" :singleTopic="singleTopic"></topic-top-meta>
                        <topic-content :topic="topic" :viewType="viewType" :expandedTopic="expandedTopic"></topic-content>
                    </div>
                </div>
            </div>
        </div>
          
        <!-- post likes & comments count -->
        <topic-stats :topic="topic" :displayMode="displayMode" :showViewsCount="showViewsCount" :likeIcon="showLikeIcon"></topic-stats>

        <!-- post comments -->
        <comments :topic="topic" v-if="!isUsersInvisibleIntroductionTopic" :viewType="viewType" :focusCommentByHashId="focusCommentByHashId" :singleTopic="singleTopic"></comments>

        <div class="align-center card-inner background-lightblue" style="border-radius: 0 0 3px 3px;" v-else>
            <div class="general-button inline-button" @click="initEditTopic(topic, true)">{{ translations['introduce.introduce'] }}</div>
        </div>
    </div>
</template>

<script>
    //mixins
    import {mapState} from 'vuex';
    import moment from 'moment';
    import Feed from '../../mixins/Feed.js';
    import Global from '../../mixins/Global.js';
    import Topic from '../../mixins/Topic.js';
    import CalendarIcon from '../events/CalendarIcon.vue';

    export default {
        mixins: [Feed, Global, Topic],

        name: 'Topic',

        components: {
            'calendar-icon': CalendarIcon,
        },

        computed: {
        	...mapState([
                'plugins'
            ]),

            start_date() {
                return moment(this.topic.event.start_date, 'YYYY-MM-DD HH:mm').format('dddd D MMMM YYYY');
            },

            eventRoute() {
                if (typeof this.$route.matched[0] !== 'undefined' && this.$route.matched[0].path === '/events') {
                    return true;
                }

                return false;
            },
        },

        data() {
            return {
                isHelpdesk: isHelpdesk,
            }
        },
    };
</script>

<style lang="scss" scoped>
    .post-top {
        .event-top {
          padding: 12px;
          padding-bottom: 0;
        }

        .event-link {
            height: 60px;
            background: #F6F7F9;

            .box-icon {
                width: 94px;

                .calendar-icon-position {
                    @apply tw-absolute;
                    bottom: -3px;
                }
            }

            .fa-chevron-right {
                @apply tw-rounded-full tw-flex tw-relative tw-bg-white tw-flex tw-items-center tw-justify-center;
                width: 32px;
                height: 32px;
                padding-left: 2px;
                padding-top: 2px;
            }

            &:hover {
                background: rgba(246, 247, 249, 0.75);

                .event-title {
                    @apply tw-opacity-75 tw-underline;
                }

                .event-start-date {
                    @apply tw-opacity-75;
                }

                .fa-chevron-right {
                    @apply tw-text-white;
                }
            }   
        }
    }
</style>
